import React, { useState } from 'react';
import LoadingScreen from './ui/LoadingScreen';

const LoadingTest: React.FC = () => {
  const [showLoading, setShowLoading] = useState(false);
  const [loadingType, setLoadingType] = useState<'auth' | 'data'>('auth');

  const simulateLoading = (type: 'auth' | 'data') => {
    setLoadingType(type);
    setShowLoading(true);
    
    // Simulate loading time
    setTimeout(() => {
      setShowLoading(false);
    }, 3000);
  };

  if (showLoading) {
    return (
      <div className="min-h-screen bg-dark-900 flex items-center justify-center">
        <LoadingScreen
          title="Loading Conversations"
          message={loadingType === 'auth' ? 'Verifying your account...' : 'Fetching your chat history...'}
        />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-dark-900 flex items-center justify-center">
      <div className="text-center space-y-4">
        <h1 className="text-3xl font-bold text-white mb-8">Loading Screen Test</h1>
        
        <div className="space-y-4">
          <button
            onClick={() => simulateLoading('auth')}
            className="block w-full px-6 py-3 bg-gradient-to-r from-accent-purple to-accent-pink text-white rounded-xl font-medium hover:shadow-lg hover:shadow-accent-purple/25 transform hover:scale-[1.02] transition-all duration-300"
          >
            Test Auth Loading (3s)
          </button>
          
          <button
            onClick={() => simulateLoading('data')}
            className="block w-full px-6 py-3 bg-gradient-to-r from-accent-pink to-accent-purple text-white rounded-xl font-medium hover:shadow-lg hover:shadow-accent-pink/25 transform hover:scale-[1.02] transition-all duration-300"
          >
            Test Data Loading (3s)
          </button>
        </div>
        
        <div className="mt-8 p-4 bg-dark-800 rounded-xl border border-dark-600">
          <h3 className="text-lg font-semibold text-white mb-2">Test Instructions:</h3>
          <ul className="text-dark-300 text-sm space-y-1 text-left">
            <li>• Click buttons to simulate different loading states</li>
            <li>• Auth loading shows "Verifying your account..."</li>
            <li>• Data loading shows "Fetching your chat history..."</li>
            <li>• Loading screen should prevent content flashing</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default LoadingTest;